import '@/components/i18n/i18/i18n.ts'
import { Provider } from 'react-redux'
import { store } from '@/redux-store/store/store.tsx'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import { Auth0Provider } from '@auth0/auth0-react'
import { AuthUser } from '@/authUser/authuser.tsx'
import './index.css'
import './tokens.css'
import { ThemeProvider } from '@/hooks/contexts/themeContext.tsx'
// import { Toaster } from '@/components/ui/toaster.tsx'
import 'react-grid-layout/css/styles.css'
import { authConfig, getENVData } from './configs/enviornment.ts'
import * as Sentry from '@sentry/react'
import React from 'react'
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router'
import packageJson from '../package.json'
import { router } from './routes/paths/routes'

interface AppState {
  returnTo?: string
}

const envData = getENVData()
const appVersion = packageJson.version

if (envData.env === 'production') {
  Sentry.init({
    dsn: 'https://79f326d7499a6ee88d08de72e6215a2a@sentry.netstratum.com/23',
    release: appVersion,
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: false,
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration({
        maskAllText: false,
        maskAllInputs: false,
        blockAllMedia: true,

        mask: [
          'input[type="password"]',
          'input[type="email"]',
          // 'input[name="username"]',
          // 'input[name="phone"]',
          // 'textarea[name="privateNote"]',
        ],
        networkDetailAllowUrls: [envData.baseURL],
        networkRequestHeaders: ['X-Custom-Header'],
        networkResponseHeaders: ['X-Custom-Header'],
      }),
      Sentry.httpClientIntegration({
        failedRequestStatusCodes: [[400, 599]], // Capture ALL failed responses
        failedRequestTargets: [new RegExp(envData.domain)],
      }),
    ],
  })
}

const onRedirectCallback = (appState?: AppState) => {
  const returnTo = appState?.returnTo || '/home'
  const navigateTo = returnTo.startsWith('/app')
    ? returnTo.replace('/app', '')
    : returnTo
  router.navigate(navigateTo, { replace: true })
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <Provider store={store}>
    <Auth0Provider
      domain={authConfig.domain}
      clientId={authConfig.clientId}
      onRedirectCallback={onRedirectCallback}
      authorizationParams={{
        redirect_uri: `${window.location.origin}/app/home`,
        scope: 'openid profile email offline_access',
        audience: authConfig.audience,
      }}
      useRefreshTokens={true}
      cacheLocation='localstorage'
    >
      <AuthUser>
        <ThemeProvider defaultTheme='light' storageKey='vite-ui-theme'>
          {/* <Toaster position='top-right' /> */}
          <App />
        </ThemeProvider>
      </AuthUser>
    </Auth0Provider>
  </Provider>,
)
